import React from 'react';

import { ProjectDiagramContextProvider } from 'src/containers/ProjectDiagram/ProjectDiagramContextProvider';
import {
  DesignerPermissionsContext,
  useDesignerPermissionsContextValue,
} from 'src/utils/hooks/useDesignerPermissions';
import {
  EditQuestionsContext,
  useEditQuestionsContextValue,
} from 'src/utils/voicebox/hooks/useEditQuestions';
import {
  EvaluateQuestionsContext,
  useEvaluateQuestionsContextValue,
} from 'src/utils/voicebox/hooks/useEvaluateQuestions';
import {
  EvaluateSummaryContext,
  useEvaluateSummaryContextValue,
} from 'src/utils/voicebox/hooks/useEvaluateSummary';

const EditQuestionsWrapper: React.VFC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const editQuestionsContextValue = useEditQuestionsContextValue();
  return (
    <EditQuestionsContext.Provider value={editQuestionsContextValue}>
      {children}
    </EditQuestionsContext.Provider>
  );
};

const EvaluateQuestionsWrapper: React.VFC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const evaluateQuestionsContextValue = useEvaluateQuestionsContextValue();
  return (
    <EvaluateQuestionsContext.Provider value={evaluateQuestionsContextValue}>
      {children}
    </EvaluateQuestionsContext.Provider>
  );
};

const EvaluateSummaryWrapper: React.VFC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const evaluateSummaryContextValue = useEvaluateSummaryContextValue();
  return (
    <EvaluateSummaryContext.Provider value={evaluateSummaryContextValue}>
      {children}
    </EvaluateSummaryContext.Provider>
  );
};

const DesignerPermissionsWrapper: React.VFC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const designerPermissionsContextValue = useDesignerPermissionsContextValue();
  return (
    <DesignerPermissionsContext.Provider
      value={designerPermissionsContextValue}
    >
      {children}
    </DesignerPermissionsContext.Provider>
  );
};

export const ProjectContextProvider: React.VFC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <ProjectDiagramContextProvider>
    <DesignerPermissionsWrapper>
      <EditQuestionsWrapper>
        <EvaluateQuestionsWrapper>
          <EvaluateSummaryWrapper>{children}</EvaluateSummaryWrapper>
        </EvaluateQuestionsWrapper>
      </EditQuestionsWrapper>
    </DesignerPermissionsWrapper>
  </ProjectDiagramContextProvider>
);
